import { useEffect, useState } from 'react';
import useTombFinance from './useTombFinance';
import useRefresh from './useRefresh';

const useTotalValueLocked = () => {
  const [totalValueLocked, setTotalValueLocked] = useState<Number>(() => {
    // Try to get cached value from localStorage on initial load
    const cached = localStorage.getItem('last_tvl');
    return cached ? Number(cached) : 0;
  });
  const { slowRefresh } = useRefresh();
  const tombFinance = useTombFinance();

  useEffect(() => {
    async function fetchTVL() {
      try {
        const tvl = await tombFinance.getTotalValueLocked();
        setTotalValueLocked(tvl);
        // Cache the new value
        localStorage.setItem('last_tvl', tvl.toString());
      }
      catch(err){
        console.error('Error fetching TVL:', err);
      }
    }
    fetchTVL();
  }, [setTotalValueLocked, tombFinance, slowRefresh]);

  return totalValueLocked;
};

export default useTotalValueLocked;
